import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrStaticPlaysByAdResponse } from '@/api/routes/static-stat/types';

import { fetchStaticAggrPlaysByAd } from './actionCreators';

interface InitialState {
  playsByAd: AggrStaticPlaysByAdResponse,
  selectedAds: string[],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  playsByAd: {},
  selectedAds: [],
  isLoading: false,
  error: '',
};

export const staticAggrPlaysByAdSlice = createSlice({
  name: 'staticAggrPlaysByAd',
  initialState,
  reducers: {
    selectAds: (state, action: PayloadAction<string[]>) => {
      state.selectedAds = action.payload;
    },
  },
  extraReducers: {
    [fetchStaticAggrPlaysByAd.fulfilled.type]: (state, action: PayloadAction<AggrStaticPlaysByAdResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.playsByAd = action.payload;
    },
    [fetchStaticAggrPlaysByAd.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticAggrPlaysByAd.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { selectAds } = staticAggrPlaysByAdSlice.actions;
export default staticAggrPlaysByAdSlice.reducer;
